export enum ClassificationEnum {
    Silver = "Silver",
    Titanium = "Titanium",
    Gold = "Gold",
    Platinum = "Platinum",
    Diamond = "Diamond"
}